







































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { Groupe, UpdateGroupeModel } from "@/api/models/groupes/groupe";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
  },
  name: "update-groupe",
})
export default class EditGroupe extends Vue {
  @Prop({ required: true, type: Boolean }) isUpdateGroupeSidebarActive!: boolean;
  @Prop({ required: true }) groupeId!: string;

  loading = false;
  required = required;
  loadingGroupe = false;

  groupe: UpdateGroupeModel = {};

  async created() {
    await this.$http.myressif.groupes
      .getById(this.groupeId)
      .then((res: Groupe) => {
        this.groupe = res;
        this.loadingGroupe = true;
      });
  }

  resetForm() {
    this.groupe = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.groupes
      .update(
        this.groupeId,
        this.groupe
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification du groupe",
            text: "Groupe modifiée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-groupes");
        this.$emit("update:is-update-groupe-sidebar-active", false);
        this.loading = false;
      });
  }
}
